import React from 'react';

function InformationIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          fill="#0E0E11"
          fillRule="nonzero"
        >
          <path d="M12,0 C5.383,0 0,5.383 0,12 C0,18.617 5.383,24 12,24 C18.617,24 24,18.617 24,12 C24,5.383 18.617,0 12,0 Z M12,23 C5.935,23 1,18.065 1,12 C1,5.935 5.935,1 12,1 C18.065,1 23,5.935 23,12 C23,18.065 18.065,23 12,23 Z" />
          <path d="M12,8.5 C11.724,8.5 11.5,8.724 11.5,9 L11.5,18.5 C11.5,18.776 11.724,19 12,19 C12.276,19 12.5,18.776 12.5,18.5 L12.5,9 C12.5,8.724 12.276,8.5 12,8.5 Z" />
          <circle
            cx="12"
            cy="6"
            r="1"
          />
        </g>
      </g>
    </svg>
  );
}

export default InformationIcon;
